<div class="contact-form p-3 mt-4">
  <div class="title text-center">Get in touch</div>
  <div class="caption text-center">Feel free to contact us and we will get in touch with you</div>

  <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="name" class="form-label">Full Name</label>
      <input type="name" class="form-control" id="name" aria-describedby="FullName" formControlName="name">
    </div>
    <div class="mb-3">
      <label for="email" class="form-label">Email</label>
      <input type="email" class="form-control" id="email" formControlName="email">
    </div>
    <div class="mb-3">
      <label for="phone" class="form-label">Phone Number</label>
      <input type="phone" class="form-control" id="phone" formControlName="phone">
    </div>
    <div class="mb-3">
      <label for="message" class="form-label">Message</label>
      <textarea class="form-control" placeholder="Leave a comment here" id="message" formControlName="description"></textarea>
    </div>
    <button type="submit" class="btn btn-primary mb-4" [disabled]="!contactForm.valid">Submit</button>

    <div class="alert alert-success" role="alert" *ngIf="showSuccess">
      Your message has been sent Successfully!
    </div>

    <div class="alert alert-danger" role="alert" *ngIf="showError">
      Your message wasn't sent. Something unexpected occured.
    </div>
  </form>
</div>